export type DashboardTimeRange = "7d" | "30d" | "90d";

export const dashboardDaysForRange = (range: DashboardTimeRange): number =>
  range === "7d" ? 7 : range === "30d" ? 30 : 90;

/** Old requests may finish, but only the latest epoch and range may commit. */
export const dashboardRequestIsCurrent = (
  requestEpoch: number,
  currentEpoch: number,
  requestedRange: DashboardTimeRange,
  currentRange: DashboardTimeRange
): boolean => requestEpoch === currentEpoch && requestedRange === currentRange;
